/**
 * Authoritative PostHog event name registry.
 * Values are snake_case following the PRD pattern: <object>_<action>.
 * Group by funnel stage for discoverability.
 */
export const PostHogEvents = {
  // ── Login (`/`, `/login`) ──
  LOGIN_PAGE_VIEWED: "login_page_viewed",
  LOGIN_SUCCEEDED: "login_succeeded",
  LOGIN_FAILED: "login_failed",
  LOGOUT: "logout",

  // ── Sign-up CTA (from login → `/signup`) ──
  SIGNUP_CTA_CLICKED: "signup_cta_clicked",

  // ── Sign-up form (`/signup`) ──
  SIGNUP_PAGE_VIEWED: "signup_page_viewed",
  SIGNUP_PAGE_DROPPED: "signup_page_dropped",
  DATA_PROTECTION_ACCEPTED: "data_protection_accepted",
  DATA_PROTECTION_DENIED: "data_protection_denied",
  VERIFY_EMAIL_MODAL_SHOWN: "verify_email_modal_shown",
  OTP_VERIFICATION_SUCCEEDED: "otp_verification_succeeded",
  OTP_VERIFICATION_FAILED: "otp_verification_failed",
  OTP_RESENT: "otp_resent",

  // ── First Sign-In / My Account ──
  MY_ACCOUNT_PAGE_VIEWED: "my_account_page_viewed",
  FIRST_SIGNIN_SUCCEEDED: "first_signin_succeeded",
  MY_ACCOUNT_DROPPED: "my_account_dropped",
  PROFILE_EDITED: "profile_edited",
  PASSWORD_CHANGED: "password_changed",
  ACCOUNT_DELETED: "account_deleted",

  // ── Book Appointment ──
  BOOK_APPOINTMENT_PAGE_VIEWED: "book_appointment_page_viewed",
  BOOK_NEW_APPOINTMENT_CLICKED: "book_new_appointment_clicked",

  // ── Application Form ──
  APPLICATION_FORM_STARTED: "application_form_started",
  APPLICATION_FORM_STEP_COMPLETED: "application_form_step_completed",
  APPLICATION_FORM_SUBMITTED: "application_form_submitted",

  // ── Slot Selection ──
  SLOT_SELECTION_PAGE_VIEWED: "slot_selection_page_viewed",
  SLOT_SELECTED: "slot_selected",
  SLOT_SELECTION_CONFIRMED: "slot_selection_confirmed",

  // ── Image Upload / Applicant Verification ──
  IMAGE_UPLOAD_PAGE_VIEWED: "image_upload_page_viewed",
  IMAGE_UPLOADED: "image_uploaded",
  VERIFICATION_OTP_SENT: "verification_otp_sent",
  VERIFICATION_OTP_SUCCEEDED: "verification_otp_succeeded",
  VERIFICATION_TERMS_AGREED: "verification_terms_agreed",
  VERIFICATION_TERMS_DENIED: "verification_terms_denied",

  // ── Liveness Detection ──
  LIVENESS_PAGE_VIEWED: "liveness_page_viewed",
  LIVENESS_CHECK_SUCCEEDED: "liveness_check_succeeded",
  LIVENESS_CHECK_FAILED: "liveness_check_failed",
  LIVENESS_CHECK_DROPPED: "liveness_check_dropped",

  // ── Booking Summary / Payment ──
  BOOKING_SUMMARY_PAGE_VIEWED: "booking_summary_page_viewed",
  BOOKING_COMPLETED: "booking_completed",
  BOOKING_SUMMARY_DROPPED: "booking_summary_dropped",

  // ── Manage Appointments ──
  MANAGE_APPOINTMENTS_PAGE_VIEWED: "manage_appointments_page_viewed",
  APPOINTMENT_CANCELLED: "appointment_cancelled",
  APPOINTMENT_LETTER_DOWNLOADED: "appointment_letter_downloaded",
  APPOINTMENT_CONFIRMATION_VIEWED: "appointment_confirmation_viewed",

  // ── Public Forms ──
  CUSTOMER_FEEDBACK_SUBMITTED: "customer_feedback_submitted",
  DOORSTEP_SERVICE_SUBMITTED: "doorstep_service_submitted",
} as const;

export type PostHogEventName = (typeof PostHogEvents)[keyof typeof PostHogEvents];
